import React, { useContext, useRef, useEffect, useState } from "react";
import classnames from "classnames";
import Styles from "./OurCustomerSays.module.scss";
import { AppContext } from "@vahak/core/dist/app-context";
import CustomCarousel from "@vahak/core/dist/components/custom-carousel/CustomCarousel";
import TestimonialCard from "../testimonial-card/TestimonialCard";

//Icons
import ArrowWhite from "@vahak/core/dist/icons/arrow-right-white.svg";

interface DataProps {
    id: number;
    name: string;
    company: string;
    location: string;
    massage: string;
    srcset: string;
    image: string;
}

interface OurCustomerSaysProps {
    customerSaysData: any[];
    sectionTitle: string;
    sectionText: string;
}

const OurCustomerSays = ({ customerSaysData, sectionTitle, sectionText }: OurCustomerSaysProps) => {
    const { isMobile } = useContext(AppContext);
    const carouselWrapperElmRef = useRef<HTMLDivElement>(null!);

    const [testimonialCardWidth, setTestimonialCardWidth] = useState<number>(0);

    useEffect(() => {
        setTestimonialCardWidth(carouselWrapperElmRef.current.offsetWidth);
    }, []);

    return (
        <section className={classnames(Styles.main, Styles.customersSaysSection)}>
            <div className={classnames(Styles.conainer, "container")}>
                <div className={Styles.heading}>
                    <h2>{sectionTitle}</h2>
                    <p>{sectionText}</p>
                </div>
                <div ref={carouselWrapperElmRef} className={Styles.carouselWrapper}>
                    <CustomCarousel
                        nextArrowClass={Styles.nextBtn}
                        prvArrowClass={Styles.prevBtn}
                        containerClass={Styles.carouselContainer}
                        rowClass={Styles.carouselRow}
                        itemClass={Styles.carouselItem}
                        activeClass={Styles.carouselActive}
                        prevNextBtnsClass={Styles.buttonsClass}
                        length={customerSaysData?.length}
                        scrollBy={1}
                        prvArrow={<ArrowWhite />}
                        nextArrow={<ArrowWhite />}
                        items={customerSaysData?.map((data, index) => (
                            <TestimonialCard key={index} data={data} width={testimonialCardWidth} />
                        ))}
                    />
                </div>
            </div>
        </section>
    );
};

export default OurCustomerSays;
